import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import Auth from './auth.module';
import Cities from './cities.module';
import Coordinators from './coordinators.module';
import Countries from './countries.module';
import Finals from './finals.module';
import GUI from './gui.module';
import Leagues from './leagues.module';
import Locations from './locations.module';
import Matches from './matches.module';
import Pitches from './pitches.module';
import PlaceholderTeams from './placeholders.module';
import Players from './players.module';
import Referees from './referees.module';
import Registrations from './registrations.module';
import Teams from './teams.module';
import Tournaments from './tournaments.module';
import ManOfTheMatches from './manofthematches.module';
import BookingsLM from './booking.module';
import redcardsModule from './redcards.module';

Vue.use(Vuex);

// Root Store - Global UI State

export default new Vuex.Store({
	state: {
		loading: true,
		warning: '',
		unsavedChanges: false,
		isMobile: false,
		breadcrumb: {
			root: '',
			path: '',
		},
		locationRound: [],
	},

	// ================ Getters ================
	getters: {
		roundLocationArry(state: any) {
			return state.locationRound;
		},

		loading(state: any) {
			return state.Leagues.leaguesLoading || state.Auth.authLoading || state.loading;
		},

		isMobile(state: any) {
			return state.isMobile;
		},

		warning(state: any) {
			return state.warning;
		},

		unsavedChanges(state: any) {
			return state.unsavedChanges;
		},

		breadcrumb(state: any) {
			return state.breadcrumb;
		},
	},

	// ================ Mutations ================
	mutations: {
		setLoadingState(state: any, bool: boolean) {
			state.loading = bool;
		},

		setWarning(state: any, text: string) {
			state.warning = text;
		},

		setUnsavedChanges(state: any, bool: boolean) {
			state.unsavedChanges = bool;
		},

		setIsMobile(state: any, bool: boolean) {
			state.isMobile = bool;
		},

		setBreadcrumb(state: any, value: string) {
			state.breadcrumb = value;
		},

		setRoundLocationArry(state: any, value: any) {
			state.locationRound = value;
		},
	},

	// ================ Actions ================
	actions: {
		async storeInit({ dispatch }: any) {
			await Promise.all([
				dispatch('getCities'),
				// dispatch('getCoordinators'),
				dispatch('getCountries'),
				dispatch('getLeagues', 'isplanned'),
				dispatch('getLocations'),
				dispatch('getPitches'),
				dispatch('getReferees'),
				dispatch('getTeams'),
				// dispatch('getManOfTheMatches'),
				// // dispatch('getLMBookings'),
				// // dispatch('getLMReports'),
				dispatch('getPlayerBookingCancled'),
				dispatch('getCustomerBookingCancled'),
				
			]);
		},
	},

	// ================ Modules ================
	modules: {
		Auth,
		Cities,
		Coordinators,
		Countries,
		Finals,
		GUI,
		Leagues,
		Locations,
		Matches,
		Pitches,
		PlaceholderTeams,
		Players,
		Referees,
		Registrations,
		Teams,
		Tournaments,
		ManOfTheMatches,
		BookingsLM,
		redcardsModule
	},
});
